(function() {
  'use strict';

  angular
  .module('irricrops')
  .factory('focus', focus);

  focus.$inject = ['$timeout', '$window'];

  /* @ngInject */
  function focus($timeout, $window) {
    return function(id) {
      // timeout makes sure that it is invoked after any other event has been triggered.
      // e.g. click events that need to run before the focus or
      // inputs elements that are in a disabled state but are enabled when those events
      // are triggered.
      $timeout(function() {
        var element = $window.document.getElementById(id);
        if(element){
          element.focus();
          if(element.setSelectionRange){
            element.setSelectionRange(0, element.value.length);
          }
        }
      });
    };
  }
})();
